import React, { useState } from "react";
import Footer from "../component/Footer";
import "../Text Modification Formatting/text.css";

const DuplicateLineRemover = () => {
  const [textareaValue, setTextareaValue] = useState("");
  const [nonDuplicateText, setNonDuplicateText] = useState("");
  const [textStatistics, setTextStatistics] = useState({
    wordCount: 0,
    letterCount: 0,
    sentenceCount: 0,
    lineCount: 0,
  });

  const handleChange = (event) => {
    const text = event.target.value;
    setTextareaValue(text);
    const uniqueLines = removeDuplicateLines(text);
    setNonDuplicateText(uniqueLines);
    setTextStatistics(calculateTextStatistics(uniqueLines));
  };

  const removeDuplicateLines = (text) => {
    const lines = text.split("\n");
    const uniqueLines = [...new Set(lines)];
    return uniqueLines.join("\n");
  };

  const calculateTextStatistics = (text) => {
    const words = text
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0);
    const letters = text.replace(/\s+/g, "").length;
    const sentences = text
      .split(/[.!?]+/)
      .filter((sentence) => sentence.trim().length > 0);
    const lines = text.split("\n");

    return {
      wordCount: words.length,
      letterCount: letters,
      sentenceCount: sentences.length,
      lineCount: lines.length,
    };
  };

  const handleDownload = () => {
    const blob = new Blob([nonDuplicateText], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "non-duplicate-text.txt";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleClear = () => {
    setTextareaValue("");
    setNonDuplicateText("");
    setTextStatistics({
      wordCount: 0,
      letterCount: 0,
      sentenceCount: 0,
      lineCount: 0,
    });
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(nonDuplicateText);
  };

  return (
    <div className="container">
      <main>
        <h1>Rabbit Case</h1>
        <div className="content">
          <h2>Online Duplicate Line Remover</h2>
          <p>
            Whether you're dealing with large data sets, cleaning up lists, or
            just need to eliminate redundant information, our tool is here to
            simplify your task. Simply paste your text and let our tool do the
            rest!
          </p>
          <div className="textarea-container">
            <textarea
            className="textarea-animated"
              value={textareaValue}
              onChange={handleChange}
              placeholder="Start typing your notes here..."
              rows="8"
            />
            <textarea
            className="textarea-animated"
              value={nonDuplicateText}
              placeholder="Converted text will appear here..."
              rows="8"
              readOnly
            />
          </div>
          <div className="stats-text">
            
              Words: {textStatistics.wordCount} | Letters:{" "}
              {textStatistics.letterCount} | Sentences:{" "}
              {textStatistics.sentenceCount} | Lines: {textStatistics.lineCount}
          
          </div>
          <div  className="btn1-container">
            <button class="btn-421" onClick={handleDownload}>Download Text</button>
            <button class="btn-421" onClick={handleCopy}>Copy to Clipboard</button>
            <button class="btn-421" onClick={handleClear}>Clear</button>
          </div>
        </div>
        <br />
        <div className="content1">
          <h3>Effortless Duplicate Line Removal</h3>
          <p>
            We understand the challenges of dealing with duplicate lines in your
            text. That's why we've developed this easy-to-use online tool to
            help you clean up your data. Our tool is perfect for professionals
            dealing with large data sets, students working on research projects,
            and anyone in need of quick and efficient duplicate line removal.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>What is the Online Duplicate Line Remover?</h3>
          <p>
            The Online Duplicate Line Remover is a free online tool that helps
            you to easily remove duplicate lines from your text. This tool is
            useful for managing large data sets, cleaning up lists, and
            eliminating redundant information.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>How do I use the Online Duplicate Line Remover?</h3>
          <p>
            To use the tool, simply paste your text into the provided field and
            on the right the tool will automatically process your text and
            provide a version free of any duplicate lines.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>Is there a limit to the size of text I can process? </h3>
          <p>
            The Online Duplicate Line Remover can handle large data sets
            efficiently. However, for best performance, we recommend processing
            text of less than 50,000 lines at a time.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>Can I use this tool for my research project?</h3>
          <p>
            Yes, the tool is perfect for anyone including students working on
            research projects. It helps you remove duplicate entries, thereby
            making your data more accurate and easier to analyze.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>Is there a cost to use the Online Duplicate Line Remover?</h3>
          <p>
            No, the Online Duplicate Line Remover is a free tool provided by
            Convertcase.net.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>
            How does the Online Duplicate Line Remover identify duplicates?
          </h3>
          <p>
            The tool identifies duplicates by comparing each line of text to
            every other line. If a line is repeated, it's flagged as a duplicate
            and removed in the final output.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>Can I save the output from the tool?</h3>
          <p>
            Yes, after the tool has removed the duplicate lines, you can
            download the output in a text file or copy it directly to your
            clipboard for immediate use
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>Can I use this tool to clean up my mailing list?</h3>
          <p>
            Yes, the Online Duplicate Line Remover tool is perfect for cleaning
            up data such as mailing lists. It helps you remove duplicate entries
            to ensure each individual or address is only listed once.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DuplicateLineRemover;
